'use es6';

import { getRecordName } from '../../../util/getRecordName';
import Raven from 'raven-js';
import memoize from 'transmute/memoize';
import { getPlainText, getRichText } from '../../../common-message-format/operators/commonMessageFormatGetters';
import CommonMessage from '../../../common-message-format/records/CommonMessage';
import InitialMessage from '../../../initial-message/records/InitialMessage';
import TypicalResponseTimeMessage from '../../../typical-response-time/records/TypicalResponseTimeMessage';
import { getEvaluatedTextContent } from './getEvaluatedTextContent';
import { getHasReplies } from '../../../common-message-format/operators/emailMetadataGetters';
import PartialMessage from '../../../partial-message/records/PartialMessage';
import CustomerAgentAutomatedMessage from '../../../customer-agent-automated-message/records/CustomerAgentAutomatedMessage';
const supportedRecordTypes = [CommonMessage, InitialMessage, TypicalResponseTimeMessage, PartialMessage, CustomerAgentAutomatedMessage];
export const hasTextContent = memoize(message => {
  if (!supportedRecordTypes.some(recordType => message instanceof recordType)) {
    Raven.captureException(new Error(`hasTextContent: Unsupported message record type ${getRecordName(message)}`));
  }
  const hasReplies = getHasReplies(message);
  const html = getRichText(message) || getPlainText(message);
  return hasReplies || Boolean(html && html.length && getEvaluatedTextContent(html));
});